import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { MembersDataService, MembersColumnsService } from '../../../services';
import { Member, MembersResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-member-details',
  templateUrl: './member-details.component.html',
  styleUrls: ['./member-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class MemberDetailsComponent implements OnInit, OnDestroy {

  public member: Member = {};
  public members: Member[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private membersDataService: MembersDataService,
    private membersColumnsService: MembersColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Member - Details');
        this.getMember(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.member !== 'undefined') {
      this.member = this.dynamicDialogConfig.data.member;
    }
    this.columns = this.membersColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getMember(id: number): void {
    this.isLoading = true;
    this.membersDataService.getMember(id).subscribe((response: Member|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.member = response;
      }
    });
  }

  list() {
    this.router.navigate(['/members']);
  }

  add() {
    this.router.navigate(['/members/add']);
  }

  edit() {
    this.router.navigate(['/members/edit/' + this.member.id]);
  }

}
@Component({
  selector: 'app-member-details',
  templateUrl: './member-details.component.html',
  styleUrls: ['./member-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogMemberDetailsComponent extends MemberDetailsComponent {
}

